<style src="./QuoteStatus.scss" lang="scss" scoped></style>
<template>
  <section class="quote-status">
    <span class="title">STATUS DOS ITENS</span>
    <div class="monitor-info">
      <ul>
        <li class="item-total" :class="{'item-total-off': !getFilterMap.includes('ALL') }" @click="filterBy('ALL')">
          <span class="value">{{ countTotalItems }}</span>
          <h5>TOTAL</h5>
        </li>
        <li class="item-quoted" :class="{'item-quoted-off': !getFilterMap.includes(1) }" @click="filterBy(1)">
          <span class="value">{{ countQuotedItems }}</span>
          <h5>COTADO</h5>
        </li>
        <li class="item-unquoted" :class="{'item-unquoted-off': !getFilterMap.includes(0) }" @click="filterBy(0)">
          <span class="value">{{ countUnquotedItems }}</span>
          <h5>PENDENTE</h5>
        </li>
        <li class="item-alert" :class="{'item-alert-off': !getFilterMap.includes('MESSAGE') }" @click="filterBy('MESSAGE')">
          <span class="value">{{ countAlertItems }}</span>
          <h5>REVISÂO</h5>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'QuoteStatus',
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      countTotalItems: 'ItemAssociation/COUNT_TOTAL_ITEMS',
      countQuotedItems: 'ItemAssociation/COUNT_QUOTED_ITEMS',
      countUnquotedItems: 'ItemAssociation/COUNT_UNQUOTED_ITEMS',
      countAlertItems: 'ItemAssociation/COUNT_ALERT_ITEMS',
      getFilterMap: 'ItemAssociation/GET_FILTER_MAP'
    })
  },
  methods: {
    filterBy (pFilter) {
      let actualFilter = [...this.getFilterMap]
      if (actualFilter.includes('ALL') && pFilter === 'ALL') return false
      if (pFilter === 'ALL') return this.$store.commit('ItemAssociation/SET_FILTER_BY', ['ALL', 0, 1, 'MESSAGE'])
      const indexAll = actualFilter.indexOf('ALL')
      if (indexAll > -1) actualFilter.splice(indexAll, 1)
      const filterIndexOf = actualFilter.indexOf(pFilter)
      if (filterIndexOf > -1) {
        actualFilter.splice(filterIndexOf, 1)
      } else {
        actualFilter.push(pFilter)
      }
      const isAll = [0, 1, 'MESSAGE'].every((item) => actualFilter.includes(item))
      if (isAll) actualFilter = ['ALL', 0, 1, 'MESSAGE']
      this.$store.commit('ItemAssociation/SET_FILTER_BY', actualFilter)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-association/components/quote-status/QuoteStatus.vue